import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import "../assets/css/candidate-tab-form.css";
import { toast } from "react-toastify";
import {
  validateEmail,
  validateMobileNumber711,
  validateAlphabetsAndSpace,
  validateUAN,
  validatePAN,
} from "../Helper/common";
import InputField from "./InputField";
import {
  getPersonalDetails,
  sendPersonalDetails,
  uploadFileViaMultipart,
  deleteSavePersonalDetails,
  getEmailVerify,
  getVerifyCompleted,
  getVerifyCompleted2,
  getUANVerify,
  getGenderListonPrefix,
} from "../Actions/personalDetailsActions";
import GetMasterData from "../Helper/masterData";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Loader from "./Common/loader";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import ConfirmationPopup from "./EmploymentForm/confirmationPopup";
import EMPCheckbox from "./EmploymentForm/empCheckbox";
import EMPRadio from "./EmploymentForm/empRadio";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import downloadicon from "../assets/img/download-icon-blue.svg";
import ImagePopup from "./ImagePopup.js";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const nonEditableFieldsAfterFirstSave = [
  "first_name",
  "middle_name",
  "last_name",
  "email_address",
];

const nameFields = [
  "first_name",
  "middle_name",
  "last_name",
];

const CandidatePersonalDetails = () => {
  const navigate = useNavigate();

  const [personalDetails, setPersonalDetails] = useState({});
  const [unsavedData, setUnsavedData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [disable, setDisabled]=useState(false);
  const [minorCandidate, setMinorCandidate] = useState(false);
  const [dateOfMarriageApplicable, setDateOfMarriageApplicable] =
    useState(false);
  const [mappingArray, setMappingArray] = useState([]);
  const [customMappingArray, setCustomMappingArray] = useState([]);
  const [isFileUploadedObject, setIsFileUploadedObject] = useState({});
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");
  const [uploadedFileKey, setUploadedFileKey] = useState(null);
  const [consentIsChecked, setConsentIsChecked] = useState(false);
  const storeData = useSelector((state) => state.personalDetails);
  const storeData2 = useSelector((state) => state.savedPersonalDetails);
  const storeData3 = useSelector((state) => state.savedFileDetails);
  const storeData4 = useSelector((state) => state.verifyEmail);
  const storeData5 = useSelector((state) => state.verifyCompleted);
  const dispatch = useDispatch();
  const { personalDetailsData, loading: getDataLoading, error } = storeData;
  const { savePersonalDetailsData } = storeData2;
  const { saveFileUploadData } = storeData3;
  const { verifyEmailData,loading: getEmailLoading, err } = storeData4;
  const { verifyCompletedData,loading: getVerifyCompletedLoading, erro } = storeData5;
  const [cvUrl, setCvUrl] = useState();
  const [downloadCv, setDownloadCv] = useState(false);
  const [role, setRole] = useState();
  const [verify, setVerify] = useState(false);
  const [emailId,setEmailId]=useState('');
  const [verifyComplete,setVerifyComplete]=useState(false);
  const [modalImage, setModalImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [uanVerificationData, setUanVerificationData] = useState(null);
  const [updatedGenderData, setUpdatedGenderData] = useState(null);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof getDataLoading !== "undefined" && getDataLoading !== null) {
      if (getDataLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [personalDetailsData]);

  useEffect(() => {
    if (typeof getEmailLoading !== "undefined" && getEmailLoading !== null) {
      if (getEmailLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getEmailLoading]);

  useEffect(() => {
    if (
      typeof personalDetailsData.data !== "undefined" &&
      personalDetailsData.data !== null
    ) {

      if(personalDetailsData.data.isVerifyEmail == 1){
        setVerify(true);
      }
      let mobileCodeIndex = null;
      let mobileCodeValue = null
      let alternateMobileCodeIndex = null;
      let alternateMobileCode = null;
      console.log(Object.keys(personalDetailsData?.data?.fields));
      if(personalDetailsData?.data?.fields) {
        let fields = personalDetailsData?.data?.fields;
        for (let key in fields) {
          if(fields[key] && fields[key]?.field_name === "mobile_code"){
            mobileCodeIndex = key ;
            mobileCodeValue = fields[key]?.value
          }

          if(fields[key] && fields[key]?.field_name === "alternate_mobile_country_code"){
            alternateMobileCodeIndex = key ;
            alternateMobileCode = fields[key]?.value
          }

        }
      }
      if(personalDetailsData?.data?.fields[alternateMobileCodeIndex] && mobileCodeValue) {
        personalDetailsData.data.fields[alternateMobileCodeIndex].value = mobileCodeValue // wrong manupulation ..should get handle in api 
      }

      for (
        let i = 0;
        i < Object.keys(personalDetailsData?.data?.fields)?.length;
        i++
      ) {
        if (
          personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.field_name === "cv_document_file"
        ) {
          setCvUrl(
            personalDetailsData?.data?.fields[
              Object.keys(personalDetailsData?.data?.fields)[i]
            ]?.preview?.preview_key
          );
          if (
            personalDetailsData?.data?.fields[
              Object.keys(personalDetailsData?.data?.fields)[i]
            ]?.preview?.preview_key
          ) {
            setDownloadCv(true);
          }
          console.log(downloadCv);
        }

        if (
          personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.field_name === "email_address"
        ) {
            setEmailId( personalDetailsData?.data?.fields[
              Object.keys(personalDetailsData?.data?.fields)[i]
            ]?.value);
        }

        if (
          personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.field_name === "date_of_birth"
        ) {
          localStorage.setItem('dob',  personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.value)
        }

        if(
          personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.field_name === "prefix" && personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.value
        ) {
          const prefixValue = personalDetailsData?.data?.fields[
            Object.keys(personalDetailsData?.data?.fields)[i]
          ]?.value
          dispatch(getGenderListonPrefix({option: prefixValue}, updatedGenderDataCallback))
        }
      }
      if (Object.keys(unsavedData).length === 0) {
      
        setPersonalDetails(personalDetailsData.data);
        createErrorData(personalDetailsData.data);
        setPersonalDataForMapping(personalDetailsData.data);
        createIsFileUploadedObject(personalDetailsData.data.fields);
      } else {
        const unsavedDataArr = _.cloneDeep(unsavedData);
        const newDataFields = _.cloneDeep(personalDetailsData.data.fields);
        const unsavedDataFields = _.cloneDeep(unsavedData.fields);
        let newParentalConsent = null;
        let parentalConsentIndex = null;

        if(personalDetailsData?.data?.other_checks){
          for(let otherCheckId in personalDetailsData?.data?.other_checks) {
            unsavedDataArr.other_checks[otherCheckId].docs = personalDetailsData?.data?.other_checks[otherCheckId].docs
          }
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }

        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "parental_consent_file") {
            newParentalConsent = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "parental_consent_file") {
            parentalConsentIndex = j;
          }
        }
        if (parentalConsentIndex) {
          unsavedDataFields[parentalConsentIndex] =
            _.cloneDeep(newParentalConsent);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }
        //
        let newCV = null;
        let cvIndex = null;
        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "cv_document_file") {
            newCV = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "cv_document_file") {
            cvIndex = j;
          }
        }
        if (cvIndex) {
          unsavedDataFields[cvIndex] = _.cloneDeep(newCV);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }
        let newBS = null;
        let bsIndex = null;
        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "bank_statement_file") {
            newBS = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "bank_statement_file") {
            bsIndex = j;
          }
        }
        if (bsIndex) {
          unsavedDataFields[bsIndex] = _.cloneDeep(newBS);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }
        let newCovid = null;
        let covidIndex = null;  

        
        // for (let i = 0; i < Object.values(newDataFields).length; i++) {
        //   if (newDataFields?.[i]?.field_name === "covid_vaccine_file") {
        //     newCovid = _.cloneDeep(newDataFields[i]);
        //   }
        // }
        // for (let j = 0; j < Object.values(unsavedDataFields).length; j++) {
        //   if (unsavedDataFields?.[j]?.field_name === "covid_vaccine_file") {
        //     covidIndex = j;
        //   }
        // }

        Object.entries(newDataFields).map(([key,value], idx) => {
          if (value?.field_name === "covid_vaccine_file") {
                newCovid = _.cloneDeep(value);
              }
        })

        Object.entries(unsavedDataFields).map(([key,value], idx) => {
          if (value?.field_name === "covid_vaccine_file") {
            covidIndex = key;
          }
        })

        if (covidIndex) {
          unsavedDataFields[covidIndex] =
            _.cloneDeep(newCovid);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }

        let newform16 = null;
        let form16Index = null;  
        
        // for (let i = 0; i < newDataFields.length; i++) {
        //   if (newDataFields[i].field_name === "form_16_file") {
        //     newform16 = _.cloneDeep(newDataFields[i]);
        //   }
        // }
        // for (let j = 0; j < unsavedDataFields.length; j++) {
        //   if (unsavedDataFields[j].field_name === "form_16_file") {
        //     form16Index = j;
        //   }
        // }

        Object.entries(newDataFields).map(([key,value], idx) => {
          if (value?.field_name === "form_16_file") {
            newform16 = _.cloneDeep(value);
              }
        })

        Object.entries(unsavedDataFields).map(([key,value], idx) => {
          if (value?.field_name === "form_16_file") {
            form16Index = key;
          }
        })
        if (form16Index) {
          unsavedDataFields[form16Index] =
            _.cloneDeep(newform16);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }
      }
    }
  }, [personalDetailsData, storeData]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      setRole(autoLoginData?.data?.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    const hasReferenceNumber =
      savePersonalDetailsData && savePersonalDetailsData.data ? true : false;
    if (hasReferenceNumber) {
      if(savePersonalDetailsData.data.group.group_id == 'profile_preview'){
        navigate(`/case-initiation/profile-preview/${savePersonalDetailsData.data.reference_number}`);
      }else{
        navigate(
          `/case-initiation/check-detail/${savePersonalDetailsData.data.reference_number}/${savePersonalDetailsData.data.group.group_id}`
        );
      }
      dispatch(deleteSavePersonalDetails());
    }
  }, [savePersonalDetailsData, storeData2]);

  useEffect(() => {
    if (saveFileUploadData.data) {
      console.log("here...", uploadedFileKey);

      const updatedPersonalDetails = _.cloneDeep(personalDetails);

      /////

      for (var i in updatedPersonalDetails.fields) {
        const fieldName = updatedPersonalDetails.fields[i].field_name;
        if (fieldName === "cv_document_file" && uploadedFileKey === fieldName) {
          console.log("jjj", saveFileUploadData.data.preview.preview_key);

          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData.data.preview.preview_key;

          if (Object.keys(personalDetails).length > 0) {
            Object.values(personalDetails.fields).map((item, index) => {
              if (item.field_name === "parental_consent_file") {
                Object.values(updatedPersonalDetails.fields).map((it) => {
                  if (it.field_name === "parental_consent_file") {
                    it.preview = item.preview;
                  }
                });
              }
            });
          }
        }
      }

      for (var i in updatedPersonalDetails.fields) {
        const fieldName = updatedPersonalDetails.fields[i].field_name;

        if (
          fieldName === "parental_consent_file" &&
          uploadedFileKey === fieldName
        ) {
          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData.data[0].preview_key;

          if (Object.keys(personalDetails).length > 0) {
            Object.values(personalDetails.fields).map((item, index) => {
              if (item.field_name === "cv_document_file") {
                Object.values(updatedPersonalDetails.fields).map((it) => {
                  if (it.field_name === "cv_document_file") {
                    it.preview = item.preview;
                  }
                });
              }
            });
          }
        }
      }

      for (var i in updatedPersonalDetails.fields) {
        const fieldName = updatedPersonalDetails.fields[i].field_name;

        if (
          fieldName === "bank_statement_file" &&
          uploadedFileKey === fieldName
        ) {
          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData.data[0].preview_key;

          if (Object.keys(personalDetails).length > 0) {
            Object.values(personalDetails.fields).map((item, index) => {
              if (item.field_name === "cv_document_file") {
                Object.values(updatedPersonalDetails.fields).map((it) => {
                  if (it.field_name === "cv_document_file") {
                    it.preview = item.preview;
                  }
                });
              }
            });
          }
        }
      }

      // for (var i in updatedPersonalDetails.fields) {
      //   const fieldName = updatedPersonalDetails.fields[i].field_name;

      //   if (
      //     fieldName === "covid_vaccine_file" &&
      //     uploadedFileKey === fieldName
      //   ) {
      //     updatedPersonalDetails.fields[i].preview.preview_key =
      //       saveFileUploadData?.data.preview?.preview_key;

      //     if (Object.keys(personalDetails).length > 0) {
      //       Object.values(personalDetails.fields).map((item, index) => {
      //         if (item.field_name === "covid_vaccine_file") {
      //           Object.values(updatedPersonalDetails.fields).map((it) => {
      //             if (it.field_name === "covid_vaccine_file") {
      //               it.preview = item.preview;
      //             }
      //           });
      //         }
      //       });
      //     }
      //   }

        // if (
        //   fieldName === "form_16_file" &&
        //   uploadedFileKey === fieldName
        // ) {
        //   updatedPersonalDetails.fields[i].preview.preview_key =
        //     saveFileUploadData?.data.preview?.preview_key;

        //   if (Object.keys(personalDetails).length > 0) {
        //     Object.values(personalDetails.fields).map((item, index) => {
        //       if (item.field_name === "form_16_file") {
        //         Object.values(updatedPersonalDetails.fields).map((it) => {
        //           if (it.field_name === "form_16_file") {
        //             it.preview = item.preview;
        //           }
        //         });
        //       }
        //     });
        //   }
        // }
      // }

      setPersonalDetails(updatedPersonalDetails);
    }
  }, [saveFileUploadData, storeData3]);

  useEffect(() => {

    if (  typeof verifyEmailData !== "undefined" &&
    verifyEmailData !== null) {
      if(verifyEmailData.status == "success"){

        setVerifyComplete(true);

          }
     
    }
  }, [verifyEmailData, storeData4]);

  useEffect(() => {

    if (  typeof verifyCompletedData !== "undefined" &&
    verifyCompletedData !== null) {
      if(verifyCompletedData?.data?.isVerified == 1 ){
        checkBeforeSave(true);
      }
      else if(verifyCompletedData?.data?.isVerified == 0){ 
        checkBeforeSave(false);
      }
     
    }
  }, [verifyCompletedData, storeData5]);


  useEffect(() => {
    const fetchData = async () => {
      dispatch(getPersonalDetails());
    };

    fetchData();
  }, []);

  const createIsFileUploadedObject = (data) => {
    const obj = {};
    for (let i in data) {
      if (data[i].field_name === "marital_status") {
        const isApplicable = data[i].value === "Married" ? true : false;
        setDateOfMarriageApplicable(isApplicable);
      }
      if (data[i].input_type == 8) {
        obj[`${data[i].field_name}`] = false;
      }
    }

    setIsFileUploadedObject(obj);
  };

  const setPersonalDataForMapping = (data) => {
    const updatedDataFields = {};
    for (var i in data.fields) {
      if (
        !["mobile_code", "alternate_mobile_country_code"].includes(
          data.fields[i].field_name
        )
      ) {
        updatedDataFields[i] = data.fields[i];
      }
    }
    const mappingDataFields = mapAnArrayWithTwoDivisions(updatedDataFields);
    // const mappingCustomFields = mapAnArrayWithTwoDivisions(data.custom_fields);
    console.log(mappingDataFields, 'ssssssss')
    const data1 = transformInput(mappingDataFields)
    setMappingArray(data1);
    // setCustomMappingArray(mappingCustomFields);
  };


  const transformInput = (input) => {
    // Flatten the input array
    const flattened = input.flat();
  
    const result = [];
    let index = 0;
  
    // Add first 2 elements to the first subarray
    result.push(flattened.slice(index, index + 2));
    index += 2;
  
    // Add next 3 elements to the second subarray
    result.push(flattened.slice(index, index + 3));
    index += 3;
  
    // Add remaining elements in subarrays of 2 elements each
    while (index < flattened.length) {
      result.push(flattened.slice(index, index + 2));
      index += 2;
    }
  
    return result;
  };


  const mapAnArrayWithTwoDivisions = (data) => {
    const mappingData = Object.keys(data).reduce(function (rows, key, index) {
      return (
        (index != 4 ? index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key) : index % 3 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) &&
        rows
      );
    }, []);

    return mappingData;
  };
  const createErrorData = (personalDetails) => {
    const errorData = {};
    for (var i in personalDetails.fields) {
      errorData[`${personalDetails.fields[i].field_name}`] = false;
    }
    for (var i in personalDetails.custom_fields) {
      errorData[`${personalDetails.custom_fields[i].slug}`] = false;
      if (i === "consent") {
        if (personalDetails.custom_fields[i].value == "1") {
          setConsentIsChecked(true);
        } else {
          setConsentIsChecked(false);
        }
      }
    }
    setErrorData(errorData);
  };
  const form = useRef();

  const updatedGenderDataCallback = (data) => {
    if(data?.gender) {
      setUpdatedGenderData(data?.gender);
    }
  }

  const handleInputChange = (e, isMandat, fieldFrom = "", otherCheckId = "") => {
    console.log("e.target", e.target)
    if (e?.target?.name === "prefix") {
      //api call 
      dispatch(getGenderListonPrefix({ option: e?.target?.value || "" }, updatedGenderDataCallback))
      // resetting the value of gender 
      const genderfield = Object.entries(personalDetails?.fields || {})?.find(field => field[1] && field[1]?.field_name === "gender");

      if (genderfield?.length) {
        const genderId = genderfield[0]
        setPersonalDetails((prevState) => ({
          ...prevState,
          fields: {
            ...prevState.fields,
            [genderId]: {
              ...prevState.fields[genderId],
              value: "",
            },
          },
        }));
      }
    }
    if (e.target.name === "marital_status") {
      const isApplicable = e.target.value === "Married" ? true : false;
      setDateOfMarriageApplicable(isApplicable);
    }
    switch (e.target.name) {
      case "mobile_no":
      case "alternate_mobile_no":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateMobileNumber711(e.target.value),
        }));
        break;
      case "email_address":
      case "alternate_email_address":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateEmail(e.target.value),
        }));
        break;
      case "first_name":
      case "middle_name":
      case "last_name":
      case "father_name":

        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
        }));
        break;
      case "prefix":
      case "gender":
      case "marital_status":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value === "" ? true : false,
        }));
        break;
      case "pan_number":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validatePAN(e.target.value)
        }));
        break;
      case "uan_number":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateUAN(e.target.value)
        }));
        break;
      default:
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: false,
        }));
    }

    if (
      e.target.name === "alternate_mobile_no" ||
      e.target.name === "mobile_no"
    ) {
      const fields = _.cloneDeep(personalDetails.fields);
      let mobileNumber = "";
      const dependentField =
        e.target.name === "alternate_mobile_no"
          ? "mobile_no"
          : "alternate_mobile_no";

      let currentFieldNumberCode = "";
      let dependentFieldCode = "";
      for (var i in fields) {
        if (fields[i].field_name == dependentField) {
          mobileNumber = fields[i].value;
        }
        if (dependentField === "alternate_mobile_no") {
          if (fields[i].field_name == "alternate_mobile_country_code") {
            dependentFieldCode = fields[i].value;
          }
          if (fields[i].field_name == "mobile_code") {
            currentFieldNumberCode = fields[i].value;
          }
        } else if (dependentField === "mobile_no") {
          if (fields[i].field_name == "mobile_code") {
            dependentFieldCode = fields[i].value;
          }
          if (fields[i].field_name == "alternate_mobile_country_code") {
            currentFieldNumberCode = fields[i].value;
          }
        }
      }
      let isValid = validateMobileNumber711(e.target.value);
      if(e.target.value == "" && isMandat == 0){
        isValid=true;
      }
      if (isValid ) {
        const mobileNumberWithCode = mobileNumber + dependentFieldCode;
        const currentFieldNumberWithCode =
          e.target.value + currentFieldNumberCode;
        if (
          mobileNumber !== "" &&
          currentFieldNumberWithCode === mobileNumberWithCode
        ) {
          setErrorData((prevState) => ({
            ...prevState,
            [e.target.name]: true,
          }));
        } else {
          setErrorData((prevState) => ({
            ...prevState,
            [e.target.name]: false,
            [dependentField]: mobileNumber
              ? !validateMobileNumber711(mobileNumber)
              : false,
          }));
        }
      } else {
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: true,
        }));
      }
    }

    // if (e.target.name === "mobile_no") {
    //   const fields = _.cloneDeep(personalDetails.fields);
    //   let altMobileNumber = "";
    //   for (var i in fields) {
    //     if (fields[i].field_name == "alternate_mobile_no") {
    //       altMobileNumber = fields[i].value;
    //     }
    //   }
    //   if (altMobileNumber !== "" && e.target.value === altMobileNumber) {
    //     setErrorData((prevState) => ({
    //       ...prevState,
    //       [e.target.name]: true,
    //     }));
    //   }
    // }
    if(fieldFrom === "other_check") {
      setPersonalDetails((prevState) => ({
        ...prevState,
        other_checks : {
          ...prevState.other_checks,
          [otherCheckId] : {
            docs : {...prevState.other_checks[otherCheckId].docs},
            fields: {...prevState.other_checks[otherCheckId].fields,
              [e.target.id] : {
                ...prevState.other_checks[otherCheckId].fields[e.target.id],
                value: e.target.value
              }
            }
          }
        }
      }))
    }
    else if (e.target.dataset.title == "field") {
      setPersonalDetails((prevState) => ({
        ...prevState,
        fields: {
          ...prevState.fields,
          [e.target.id]: {
            ...prevState.fields[e.target.id],
            value: e.target.value,
          },
        },
      }));
    } else {
      setPersonalDetails((prevState) => ({
        ...prevState,
        custom_fields: {
          ...prevState.custom_fields,
          [e.target.id]: {
            ...prevState.custom_fields[e.target.id],
            value: e.target.value,
          },
        },
      }));
    }
  };

  const saveDate = (id, val) => {
    if (val == "Invalid date") {
      val = "";
      const errorField = personalDetails.fields[id].field_name;
      let newErr = _.cloneDeep(errorData);
      newErr[errorField] = true;
      setErrorData(newErr);
    } else {
      const errorField = personalDetails.fields[id].field_name;
      let newErr = _.cloneDeep(errorData);
      newErr[errorField] = false;
      setErrorData(newErr);
      localStorage.setItem("dob", val);
    }

    setPersonalDetails((prevState) => ({
      ...prevState,
      fields: {
        ...prevState.fields,
        [id]: {
          ...prevState.fields[id],
          value: val,
        },
      },
    }));
  };

  const checkBeforeSave1 = async (e) => {


    // e.preventDefault();
    if(verify == true){
      let hasError = false;
    for (let i in personalDetails.fields) {
      if (
        personalDetails.fields[i].is_mandatory === 1 &&
        (personalDetails.fields[i].value === "" ||
          personalDetails.fields[i].value === null)
      ) {
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          !minorCandidate
        ) {
          continue;
        }
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          minorCandidate
        ) {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "cv_document_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        
        if (personalDetails.fields[i].field_name === "bank_statement_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (
          personalDetails.fields[i].field_name === "date_of_marriage" &&
          !dateOfMarriageApplicable
        ) {
          continue;
        }
        if (personalDetails.fields[i].field_name === "covid_vaccine_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "form_16_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        //remove later
        if (
          ["candidate_photo", "fv_id_card_file"].includes(
            personalDetails.fields[i].field_name
          )
        ) {
          continue;
        }

        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [personalDetails.fields[i].field_name]: true,
        }));
      } else if (personalDetails.fields[i].field_name === "uan_number" && personalDetailsData.data?.isUanVerified !=
        1 && uanVerificationData?.data?.api_hit_count != 3 && uanVerificationData?.data?.status != "success") { // != 3 in case of handling undefined api count also
        hasError = true;
        // setErrorData((prevState) => ({
        //   ...prevState,
        //   [personalDetails.fields[i].field_name]: true,
        // }));

        let errorMsg = "Please verify your UAN number and then proceed.";
        toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    for (let i in personalDetails.custom_fields) {
      if (
        personalDetails.custom_fields[i].is_mandatory == 1 &&
        (personalDetails.custom_fields[i].value == "" ||
          personalDetails.custom_fields[i].value == null)
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [personalDetails.custom_fields[i].slug]: true,
        }));
      }
    }
    for (let otherCheckId in personalDetails.other_checks) {
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.fields){
        for(let fieldIndex in personalDetails.other_checks[otherCheckId]?.fields) {
          if(personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].is_mandatory == 1 &&
            (personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == "" ||
              personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == null)) {
                hasError = true;
                setErrorData((prevState) => ({
                  ...prevState,
                  [personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].field_name]: true,
                }));
              }
        }
      }
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.docs){
        for(let docIndex in personalDetails.other_checks[otherCheckId]?.docs) {
          if(personalDetails.other_checks[otherCheckId]?.docs[docIndex].is_mandatory == 1 &&
            !(personalDetails.other_checks[otherCheckId]?.docs[docIndex].preview)) {
                hasError = true;
                setErrorData((prevState) => ({
                  ...prevState,
                  [personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]: true,
                }));
              }
        }
      }
    }
    for (var i in errorData) {
      if (errorData[i] == true) {
        hasError = true;
        break;
      }
    }
    if (hasError) {
      setIsLoading(false);
      return;
    }
    }
    let record2={};
    record2.case_id=personalDetailsData.data?.ini_case_id;
    // let data;
    // if(personalDetailsData.data?.isVerifyEmail){
    const data=await dispatch(getVerifyCompleted2(record2));
      console.log("update",data);
    // }
    if(verify==false){
      checkBeforeSave(true);
      return false;
    }
  
    console.log(personalDetails);

    if(data?.data?.isVerified == 0 && data?.status == "success"){
      
       console.log(personalDetails);
      let errorMsg="Please verify your Email Account first  and then proceed";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(personalDetails);
      return false;
    }
    
    let record={};
    record.case_id=personalDetailsData.data?.ini_case_id;
    dispatch(getVerifyCompleted(record,personalDetailsData.data?.showProfilePreview));
  }


  console.log("persDet",personalDetails);


  const checkBeforeSave = (val) => {

    if (
      personalDetails.isCreditConfirmation &&
      personalDetails.isCreditConfirmation == 1
    ) {
      setShowConfirmationPopup(true);
      const isIndianMobile =
        personalDetails.fields[8] && personalDetails.fields[8].value == 91
          ? true
          : false;
      if (isIndianMobile) {
        setPopupMsg(
          "This information will be used to validate your credit history and other checks, kindly ensure that the information provided by you is accurate. You will NOT be able to modify these details later. Do you wish to proceed?"
        );
      } else {
        setPopupMsg(
          "Kindly provide an active Indian mobile number registered with your bank and credit cards on which you are receiving SMS and is currently accessible to you. Do you wish to proceed?"
        );
      }
    } else {
      saveProfileDetails(val);
    }
  };
  const saveProfileDetails = async (val) => {
    setIsLoading(true);
    let hasError = false;
    for (let i in personalDetails.fields) {
      if (
        personalDetails.fields[i].is_mandatory === 1 &&
        (personalDetails.fields[i].value === "" ||
          personalDetails.fields[i].value === null)
      ) {
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          !minorCandidate
        ) {
          continue;
        }
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          minorCandidate
        ) {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "cv_document_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "bank_statement_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (
          personalDetails.fields[i].field_name === "date_of_marriage" &&
          !dateOfMarriageApplicable
        ) {
          continue;
        }
        if (personalDetails.fields[i].field_name === "covid_vaccine_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "form_16_file") {
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        //remove later
        if (
          ["candidate_photo", "fv_id_card_file"].includes(
            personalDetails.fields[i].field_name
          )
        ) {
          continue;
        }

        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [personalDetails.fields[i].field_name]: true,
        }));
      } else if (personalDetails.fields[i].field_name === "uan_number" && personalDetailsData.data?.isUanVerified !=
        1 && uanVerificationData?.data?.api_hit_count != 3 && uanVerificationData?.data?.status != "success") {
        hasError = true;
        // setErrorData((prevState) => ({
        //   ...prevState,
        //   [personalDetails.fields[i].field_name]: true,
        // }));
        let errorMsg = "Please verify your UAN number and then proceed.";
        toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    for (let i in personalDetails.custom_fields) {
      if (
        personalDetails.custom_fields[i].is_mandatory == 1 &&
        (personalDetails.custom_fields[i].value == "" ||
          personalDetails.custom_fields[i].value == null)
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [personalDetails.custom_fields[i].slug]: true,
        }));
      }
    }
    for (let otherCheckId in personalDetails.other_checks) {
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.fields){
        for(let fieldIndex in personalDetails.other_checks[otherCheckId]?.fields) {
          if(personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].is_mandatory == 1 &&
            (personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == "" ||
              personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == null)) {
                hasError = true;
                setErrorData((prevState) => ({
                  ...prevState,
                  [personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].field_name]: true,
                }));
              }
        }
      }
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.docs){
        for(let docIndex in personalDetails.other_checks[otherCheckId]?.docs) {
          if(personalDetails.other_checks[otherCheckId]?.docs[docIndex].is_mandatory == 1 &&
            !(personalDetails.other_checks[otherCheckId]?.docs[docIndex].preview)) {
                hasError = true;
                setErrorData((prevState) => ({
                  ...prevState,
                  [personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]: true,
                }));
              }
        }
      }
    }
    for (var i in errorData) {
      if (errorData[i] == true) {
        hasError = true;
        break;
      }
    }
    if (hasError) {
      setIsLoading(false);

      let errorMsg="Please fill all the mandatory fields.";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      
      return;
    }
    const formData = getFormData();
    if(val == false){
      let errorMsg = "Please verify your Email Account first and then proceed.";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    await dispatch(sendPersonalDetails(formData));
    // navigate("/candidate-form/national-id");
  };

  const getFormData = () => {
    const formData = {};
    const customFieldsData = {};
    const otherCheckFieldsData = {};
    for (var i in personalDetails.fields) {
      formData[`${personalDetails.fields[i].field_name}`] =
        personalDetails.fields[i].value;
      if(personalDetails.fields[i].field_name == "current_address"){
        customFieldsData[`${personalDetails.fields[i].field_name}`] =
          personalDetails.fields[i].value;
      }
    }
    for (var i in personalDetails.custom_fields) {
      if (personalDetails.custom_fields[i].value.length > 0) {
        customFieldsData[`${personalDetails.custom_fields[i].slug}`] =
          personalDetails.custom_fields[i].value;
      }
    }

    for(let otherCheckId in personalDetails.other_checks){
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.fields){
        for(let fieldIndex in personalDetails.other_checks[otherCheckId]?.fields) {
          let otherCheckFieldName = personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].field_name;
          let otherCheckFieldValue = personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value;
          formData[otherCheckFieldName] = otherCheckFieldValue
        }
      }
    }
    // formData = {...formData, ...otherCheckFieldsData}
    formData["customfields_data"] = customFieldsData;
    // formData["otherCheck_data"] = otherCheckFieldsData;
    return formData;
  };


  const [cvFileName, setCvFileName] = useState();

  const handleFileUpload = async (fieldName, file) => {
    console.log("fieldName....", fieldName)
    // console.log('z',file);
    setIsLoading(true);
    setUploadedFileKey(fieldName);
    await dispatch(uploadFileViaMultipart(fieldName, file));
    setErrorData((prevState) => ({
      ...prevState,
      [fieldName]: false,
    }));
    setIsFileUploadedObject((prevState) => ({
      ...prevState,
      [fieldName]: true,
    }));
    setIsLoading(false);
    fetchUpdatedData();
    if (file) {
      setDownloadCv(true);
    }
  };

  const handleCountryCode = (e) => {
    let updatedPersonalDetailsFields = _.cloneDeep(personalDetails.fields);
    if (
      e.target.name === "alternate_mobile_no" ||
      e.target.name === "mobile_no"
    ) {
      const fields = _.cloneDeep(personalDetails.fields);
      let dependentMobileNumber = "";
      let dependentMobileCode = "";
      let currentMobileNumber = "";
      let currentMobileCode = e.target.value;

      const dependentField =
        e.target.name === "alternate_mobile_no"
          ? "mobile_no"
          : "alternate_mobile_no";

      for (var i in fields) {
        if (fields[i].field_name == dependentField) {
          dependentMobileNumber = fields[i].value;
        }
        if(fields[i].field_name == "alternate_mobile_country_code" || fields[i].field_name == "mobile_code") {
          dependentMobileCode = e?.target?.value;
          updatedPersonalDetailsFields[i].value = e.target.value;
        }
        if (dependentField === "alternate_mobile_no") {
          // if (fields[i].field_name == "alternate_mobile_country_code") {
          //   dependentMobileCode = fields[i].value;
          // }
          if (fields[i].field_name == "mobile_no") {
            currentMobileNumber = fields[i].value;
          }
        } else if (dependentField === "mobile_no") {
          // if (fields[i].field_name == "mobile_code") {
          //   dependentMobileCode = fields[i].value;
          // }
          if (fields[i].field_name == "alternate_mobile_no") {
            currentMobileNumber = fields[i].value;
          }
        }
      }

      const dependentMobileNumberWithCode =
        dependentMobileCode + dependentMobileNumber;
      const currentMobileNumberWithCode =
        currentMobileCode + currentMobileNumber;

      if (currentMobileNumberWithCode == dependentMobileNumberWithCode) {
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: true,
        }));
      } else {
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: currentMobileNumber ? !validateMobileNumber711(currentMobileNumber) : false,
          [dependentField]: dependentMobileNumber ? !validateMobileNumber711(dependentMobileNumber) : false,
        }));
      }
    }

    // const index = e.target.name === "mobile_no" ? 8 : 10;
    // updatedPersonalDetailsFields[index].value = e.target.value;
    let updatedPersonalDetails = _.cloneDeep(personalDetails);
    updatedPersonalDetails.fields = _.cloneDeep(updatedPersonalDetailsFields);
    setPersonalDetails(updatedPersonalDetails);
  };
  const fetchUpdatedData = async () => {
    setUnsavedData(personalDetails);
    dispatch(getPersonalDetails());
  };

  const closeConfirmationPopup = () => {
    setShowConfirmationPopup(false);
  };

  const proceedConfirm = () => {
    setShowConfirmationPopup(false);
    saveProfileDetails();
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  const {
    genderOptions,
    prefixOptions,
    maritalOptions,
    birthCountryOptions,
    countryCodeOptions,
  } = GetMasterData();
  const optionsKey = {
    prefix: prefixOptions,
    gender: genderOptions,
    marital_status: maritalOptions,
    birth_country: birthCountryOptions,
    mobile_no: countryCodeOptions,
    alternate_mobile_no: countryCodeOptions,
  };

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    setPersonalDetails((prevState) => ({
      ...prevState,
      custom_fields: {
        ...prevState.custom_fields,
        [dataset.fieldname]: {
          ...prevState.custom_fields[dataset.fieldname],
          value: value,
        },
      },
    }));
    setErrorData((prevState) => ({
      ...prevState,
      [dataset.fieldname]: false,
    }));
  };

  const handleCvDownload = (e) => {
    e.preventDefault();
    let url = saveFileUploadData?.data?.preview?.preview_key || cvUrl;
    const aElement = document.createElement("a");
    aElement.setAttribute("download", "download");
    // const href = URL.createObjectURL(obj);
    aElement.href = url;
    aElement.setAttribute("target", "_blank");
    aElement.click();
  };

  const handleVerify = (val,e) => {
    e.preventDefault();
    let record={};
    record.email=val;
    record.case_id=personalDetailsData.data?.ini_case_id;
    dispatch(getEmailVerify(record));  
  };

  const handleUANVerification = (val, e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    setIsLoading(true);
    dispatch(getUANVerify({uan_number: val}, getUANverificationResponse));
  }

  const getUANverificationResponse = (data) => {
    //success response
    setIsLoading(false);
    const demoData = {
      "status": "success",
      "code": 200,
      "data": {
          "status": "success",
          "msg": "Uan number has been verified successfully",
          "api_hit_count": 0
      }
  }
  setUanVerificationData(data);
    console.log("response data ", data)
  }

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset } = checkboxValues;
    const checkVal = consentIsChecked ? "" : "1";
    setConsentIsChecked(!consentIsChecked);
    setPersonalDetails((prevState) => ({
      ...prevState,
      custom_fields: {
        ...prevState.custom_fields,
        [dataset.fieldname]: {
          ...prevState.custom_fields[dataset.fieldname],
          value: checkVal,
        },
      },
    }));
    setErrorData((prevState) => ({
      ...prevState,
      [dataset.fieldname]: false,
    }));
  };

  const handleImageModal = (e, imagePreview) => {
    e.preventDefault();
    setModalImage(imagePreview);
    setShowImageModal(!showImageModal);
  };

  const closePopup = () => {
    setModalImage("");
    setShowImageModal(false);
  };

  const closeSubmitPopup = () => {
    setShowSubmitPopup(false);
  };

  const proceedSubmit = (e) => {
    setShowSubmitPopup(false);
    checkBeforeSave1(e);
  };

  const SubmitPopup = (e) => {
    e.preventDefault()
    setShowSubmitPopup(true);
  }

  // const handleDelete = async (e, docside) => {
  //   e.preventDefault();
  //   const recordArray = {};
  //   recordArray.doc_chk = eAadhaarData.checksDetails[0].case_check_id;
  //   recordArray.doc_ids =
  //     eAadhaarData.checksDetails[0].required_documents[0].id;
  //   recordArray.doc_ref = "all";
  //   recordArray.doc_side = docside;
  //   removeFile("check_documents", recordArray, aadhaarData);
  // };

  // useEffect(() => {
  //   console.log("OtherCheck....", personalDetails?.other_checks)
  // })
  return (
    <>
      {showImageModal && (
        <ImagePopup
          showModalBox={1}
          title={"Uploaded file"}
          description={"..."}
          isAdd={true}
          image={modalImage}
          closePopup={closePopup}
        />
      )}
      <NotificationPanels />
      {role == "EP" ? <ClientHeader /> : <Header />}
      {role == "EP" ? <ClientSideBar /> : <Sidebar />}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {isLoading && <Loader />}
        {showConfirmationPopup && (
          <ConfirmationPopup
            showModalBox={1}
            closePopup={closeConfirmationPopup}
            title="Credit history"
            description={popupMsg}
            proceedHandler={proceedConfirm}
            // isAdd={false}
            // checkStatus={catchIfAnyStatusIsNotCompleted}
          />
        )}

        {showSubmitPopup && (
          <ConfirmationPopup
            showModalBox={1}
            closePopup={closeSubmitPopup}
            // title="Please make sure all the details are correct."
            description={"Please make sure all the details are correct before proceeding."}
            proceedHandler={proceedSubmit}
            // isAdd={false}
            // checkStatus={catchIfAnyStatusIsNotCompleted}
          />
        )}

        {Object.keys(personalDetails).length > 0 && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto w-100-mbl bg-gray-mbl">
               <ProgressHeading/>
                <CandidateTab activeTab={"personal"} />
              </div>
              <div className="col bg-gray-mbl">
                {/*Form*/}
                <form ref={form} className="p-3 form2 form-section">
                  <StepCount activeTab={"personal"} />
                  <h2 className="fnt-smi-bld">Personal Details</h2>
                  <p className="text-muted">Enter your personal details</p>
                  <hr />

                  {mappingArray.map((mappingArr) => {
      
                    return (
                      <div className="row">
                        {mappingArr.map((arr) => {
                          const fieldName =
                            personalDetails.fields[arr].field_name;
                          const countryCodeVal =
                            fieldName === "mobile_no"
                              ? personalDetails.fields[8].value
                              : fieldName === "alternate_mobile_no"
                              ? personalDetails.fields[10].value
                              : null;
                          const dateOfBirth = personalDetails.fields[7]
                            ? personalDetails.fields[7].value
                            : null;
                            console.log(personalDetails.fields[arr].field_name, 'zzz')
                          return (
                            <>
                              {personalDetails.fields[arr].field_name ===
                              "parental_consent_file" ? (
                                minorCandidate ? (
                                  <div className="col-sm-4 col-md-12 col-xl-4">
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          personalDetails.fields[arr].input_type
                                        }
                                        inputName={
                                          personalDetails.fields[arr].field_name
                                        }
                                        inputValue={
                                          personalDetails.fields[arr].value
                                        }
                                        errorField={
                                          personalDetails.fields[arr].field_name
                                        }
                                        uploadedFilePreview={
                                          personalDetails.fields[arr].preview &&
                                          personalDetails.fields[arr].preview
                                            .preview_key
                                            ? personalDetails.fields[arr]
                                                .preview.preview_key
                                            : "n.a."
                                        }
                                        isInputMandatory={
                                          personalDetails.fields[arr]
                                            .is_mandatory
                                        }
                                        inputLabel={
                                          personalDetails.fields[arr].label
                                        }
                                        parentalTemplateUrl={
                                          personalDetails.fields[arr]
                                            .parental_template_url
                                        }
                                        index={arr}
                                        handleOnChange={(e)=>handleInputChange(e, personalDetails.fields[arr].is_mandatory)}
                                        options={
                                          optionsKey[
                                            personalDetails.fields[arr]
                                              .field_name
                                          ]
                                            ? optionsKey[
                                                personalDetails.fields[arr]
                                                  .field_name
                                              ]
                                            : []
                                        }
                                        setMinorCandidate={(isMinor) =>
                                          setMinorCandidate(isMinor)
                                        }
                                        saveDate={saveDate}
                                        handleFileUpload={handleFileUpload}
                                        isFileUploadedObject={
                                          isFileUploadedObject
                                        }
                                        isField={true}
                                      />
                                      {errorData[
                                        personalDetails.fields[arr].field_name
                                      ] === true && (
                                        <p className="text-danger">
                                          Please upload parental consent
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )
                              ) : personalDetails.fields[arr].field_name ===
                                "date_of_marriage" ? (
                                dateOfMarriageApplicable ? (
                                  <div className="col-sm-4 col-md-12 col-xl-4">
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          personalDetails.fields[arr].input_type
                                        }
                                        inputName={
                                          personalDetails.fields[arr].field_name
                                        }
                                        inputValue={
                                          personalDetails.fields[arr].value
                                        }
                                        isInputMandatory={
                                          personalDetails.fields[arr]
                                            .is_mandatory
                                        }
                                        inputLabel={
                                          personalDetails.fields[arr].label
                                        }
                                        index={arr}
                                        handleOnChange={(e)=>handleInputChange(e, personalDetails.fields[arr].is_mandatory)}
                                        options={
                                          optionsKey[
                                            personalDetails.fields[arr]
                                              .field_name
                                          ]
                                            ? optionsKey[
                                                personalDetails.fields[arr]
                                                  .field_name
                                              ]
                                            : []
                                        }
                                        setMinorCandidate={(isMinor) =>
                                          setMinorCandidate(isMinor)
                                        }
                                        saveDate={saveDate}
                                        handleFileUpload={handleFileUpload}
                                        isFileUploadedObject={
                                          isFileUploadedObject
                                        }
                                        isField={true}
                                        dateOfBirth={dateOfBirth}
                                      />
                                      {errorData[
                                        personalDetails.fields[arr].field_name
                                      ] === true ? (
                                        personalDetails.fields[arr].value ===
                                          "" ||
                                        personalDetails.fields[arr].value ===
                                          null ? (
                                          <p className="text-danger">
                                            This is a required field.
                                          </p>
                                        ) : (
                                          <p className="text-danger">
                                            Please provide valid input
                                          </p>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )
                              ) : personalDetails.fields[arr].field_name ===
                                "cv_document_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={"cv-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {downloadCv == true ? (
                                      <p onClick={(e) => handleCvDownload(e)}>
                                        <img src={downloadicon} height={20} />{" "}
                                        Download CV
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                    {personalDetails.fields[arr].field_name ===
                                    "cv_document_file" ? (
                                      <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - pdf, png & jpeg are
                                        preferred
                                      </small>
                                    ) : (
                                      <></>
                                    )}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload CV file
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ) : personalDetails.fields[arr].field_name ===
                                "bank_statement_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={"bs-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {personalDetails.fields[arr].field_name ===
                                    "bank_statement_file" ? (
                                      <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - pdf, png & jpeg are
                                        preferred
                                      </small>
                                    ) : (
                                      <></>
                                    )}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload Bank statement
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ): 
                              personalDetails.fields[arr].field_name ===
                                "covid_vaccine_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={
                                        personalDetails.fields[arr].field_name
                                      }
                                      // errorField={"bs-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      handleImageModal={handleImageModal}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {personalDetails.fields[arr].field_name ===
                                    "covid_vaccine_file" ? (
                                      <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - pdf, png & jpeg are
                                        preferred
                                      </small>
                                    ) : (
                                      <></>
                                    )}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload covid vaccine document.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ): 
                              personalDetails.fields[arr].field_name ===
                               "form_16_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={
                                        personalDetails.fields[arr].field_name
                                      }
                                      // errorField={"bs-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      handleImageModal={handleImageModal}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {personalDetails.fields[arr].field_name ===
                                    "form_16_file" ? (
                                      <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - pdf, png & jpeg are
                                        preferred
                                      </small>
                                    ) : (
                                      <></>
                                    )}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload Form 16 document.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ): 
                              (
                                <>
                                  <div className={`${nameFields.includes(personalDetails.fields[arr].field_name) ? "col-sm-4 col-md-12 col-xl-2" : "col-sm-4 col-md-12 col-xl-3" }`}>
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          personalDetails.fields[arr].input_type
                                        }
                                        inputName={
                                          personalDetails.fields[arr].field_name
                                        }
                                        inputValue={
                                          personalDetails.fields[arr].value
                                        }
                                        isInputMandatory={
                                          personalDetails.fields[arr].is_mandatory
                                        }
                                        inputLabel={
                                          personalDetails.fields[arr].label
                                        }
                                        countryCodeValue={countryCodeVal}
                                        handleCountryCode={(e) =>
                                          handleCountryCode(e)
                                        }
                                        index={arr}
                                        handleOnChange={(e) => handleInputChange(e, personalDetails.fields[arr].is_mandatory)}
                                        options={
                                          personalDetails?.fields[arr]?.field_name == "gender" && updatedGenderData ? updatedGenderData :
                                          optionsKey[
                                            personalDetails.fields[arr].field_name
                                          ]
                                            ? optionsKey[
                                            personalDetails.fields[arr]
                                              .field_name
                                            ]
                                            : []
                                        }
                                        setMinorCandidate={(isMinor) =>
                                          setMinorCandidate(isMinor)
                                        }
                                        saveDate={saveDate}
                                        handleFileUpload={handleFileUpload}
                                        isFileUploadedObject={
                                          isFileUploadedObject
                                        }
                                        isField={true}
                                        readOnly={nonEditableFieldsAfterFirstSave.includes(
                                          personalDetails.fields[arr].field_name
                                        ) || (personalDetails.fields[arr].field_name == "uan_number" && !!(personalDetailsData.data?.isUanVerified == 1 
                                          || uanVerificationData?.data?.status == "success" 
                                          || uanVerificationData?.data?.api_hit_count == 3))
                                          || personalDetails.fields[arr].field_name == "date_of_birth" && personalDetails?.personal_details_completed && (personalDetailsData?.data?.fields[arr]?.value != "" && personalDetailsData?.data?.fields[arr]?.value != null)
                                        }
                                      />
                                      {personalDetails.fields[arr].field_name ==
                                        "email_address" &&
                                        personalDetailsData.data?.isVerifyEmail ==
                                        1 && (
                                          <button
                                            className="btn btn-primary btn-lg btn-block mt-3"
                                            disabled={(personalDetailsData.data?.isEmailVerified ==
                                              1 ||
                                              verifyComplete == true)}
                                            onClick={(e) =>
                                              handleVerify(
                                                personalDetails.fields[arr].value,
                                                e
                                              )
                                            }
                                          >
                                            {(personalDetailsData.data?.isEmailVerified ==
                                              1) ? "Verified" : "Verify"}
                                          </button>
                                        )}
                                      {/* {personalDetails.fields[arr].field_name == "email_address" && personalDetailsData.data?.isVerifyEmail == 1 && personalDetailsData.data?.isEmailVerified == 0 ? <button  className="btn btn-primary btn-lg btn-block mt-3" onClick={(e)=>handleVerify(personalDetails.fields[arr].value,e)}>Verify</button>:''}
                        {personalDetails.fields[arr].field_name == "email_address" && personalDetailsData.data?.isVerifyEmail == 1 && personalDetailsData.data?.isEmailVerified == 1 ? <button  className="btn btn-primary btn-lg btn-block mt-3" disabled >Verified</button>:''} */}

                                      {errorData[
                                        personalDetails.fields[arr].field_name
                                      ] === true ? (
                                        personalDetails.fields[arr].value ===
                                          "" ||
                                          personalDetails.fields[arr].value ===
                                          null ? (
                                          <p className="text-danger">
                                            This is a required field.
                                          </p>
                                        ) : (
                                          <p className="text-danger">
                                            Please provide valid input
                                          </p>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                  {personalDetails.fields[arr].field_name ==
                                    "uan_number" &&
                                    <div className="col-sm-4 col-md-2 col-xl-2">
                                      <button
                                        className="btn btn-primary btn-lg btn-block"
                                        disabled={!personalDetails.fields[arr].value
                                          || errorData[personalDetails.fields[arr].field_name] === true
                                          || personalDetailsData.data?.isUanVerified == 1 
                                          || uanVerificationData?.data?.status == "success" 
                                          || uanVerificationData?.data?.api_hit_count == 3 } // check for updated status without page refresh
                                        onClick={(e) =>
                                          handleUANVerification(
                                            personalDetails.fields[arr].value,
                                            e
                                          )
                                        }
                                      >
                                        {(personalDetailsData.data?.isUanVerified == 1 
                                          || uanVerificationData?.data?.status == "success") ? "Verified" : "Verify"}
                                      </button>
                                    </div>

                                  }
                                </>
                              )}
                            </>
                          );
                        })}
                      </div>
                    );
                  })}

                  {customMappingArray.map((customMappingArr) => {
                    return (
                      <div className="row">
                        {customMappingArr.map((arr) => {
                          return (
                            <>
                              <div className="col-sm-4 col-md-12 col-xl-4">
                                <div className="form-group">
                                  <InputField
                                    inputType={
                                      personalDetails.custom_fields[arr]
                                        .input_type
                                    }
                                    inputName={
                                      personalDetails.custom_fields[arr].slug
                                    }
                                    inputValue={
                                      personalDetails.custom_fields[arr].value
                                    }
                                    isInputMandatory={
                                      personalDetails.custom_fields[arr]
                                        .is_mandatory
                                    }
                                    inputLabel={
                                      personalDetails.custom_fields[arr].label
                                    }
                                    index={arr}
                                    handleOnChange={handleInputChange}
                                    options={
                                      optionsKey[
                                        personalDetails.custom_fields[arr].slug
                                      ]
                                        ? optionsKey[
                                            personalDetails.custom_fields[arr]
                                              .slug
                                          ]
                                        : []
                                    }
                                    isField={false}
                                  />
                                  {errorData[
                                    personalDetails.custom_fields[arr].slug
                                  ] && (
                                    <p className="text-danger">
                                      Please provide valid input
                                    </p>
                                  )}
                                  {errorData[
                                    personalDetails.custom_fields[arr].slug
                                  ] === true ? (
                                    personalDetails.custom_fields[arr].value ===
                                      "" ||
                                    personalDetails.custom_fields[arr].value ===
                                      null ? (
                                      <p className="text-danger">
                                        This is a required field.
                                      </p>
                                    ) : (
                                      <p className="text-danger">
                                        Please provide valid input
                                      </p>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    );
                  })}

                  {personalDetails.custom_fields && (
                    <div className="row">
                      {personalDetails.custom_fields["relation_bank"] && (
                        <EMPRadio
                          name={`relation_bank`}
                          id={`relation_bank`}
                          label={
                            personalDetails.custom_fields["relation_bank"].label
                          }
                          isRequired={
                            personalDetails.custom_fields["relation_bank"]
                              .is_mandatory
                          }
                          errId={`relation_bank`}
                          fieldName={
                            personalDetails.custom_fields["relation_bank"].slug
                          }
                          fieldValue={
                            personalDetails.custom_fields["relation_bank"].value
                          }
                          checkDetailsIndex={"relation_bank"}
                          options={{ Yes: "yes", No: "no" }}
                          handleRadioChange={handleRadioChange}
                          hasError={errorData["relation_bank"]}
                        />
                      )}
                    </div>
                  )}

                  {personalDetails.custom_fields && (
                    <div className="row">
                      {personalDetails.custom_fields["consent"] && (
                        <EMPCheckbox
                          name={`consent`}
                          id={`consent`}
                          label={personalDetails.custom_fields["consent"].label}
                          isRequired={
                            personalDetails.custom_fields["consent"]
                              .is_mandatory
                          }
                          handleCheckboxChange={handleCheckboxChange}
                          // checkDetailsIndex={key}
                          fieldName={
                            personalDetails.custom_fields["consent"].slug
                          }
                          fieldValue={
                            personalDetails.custom_fields["consent"].value
                          }
                          hasError={errorData["consent"]}
                        />
                      )}
                    </div>
                  )}
                                    {
                    !!(personalDetails.other_checks && Object.entries(personalDetails?.other_checks || {}).length) &&
                    <div className="mb-3">
                      <h6 className="fnt-smi-bld mb-1">Other Check Details</h6>
                    </div>
                  }
                  {personalDetails.other_checks && Object.entries(personalDetails?.other_checks || {}).map(checkDetail => {
                    const checkId = checkDetail[0];
                    const checkFieldnDoc = checkDetail[1];
                    console.log("other check detail...", checkDetail[1])
                    return (
                      <>
                      <div className="row">
                        {
                          checkFieldnDoc?.fields && Object.entries(checkFieldnDoc?.fields || {})?.length > 0 && (
                            Object.entries(checkFieldnDoc?.fields)?.map((field, index) => {
                              console.log("fields other details...", field)
                              return (
                                <>
                                  <div className="col-sm-4 col-md-12 col-xl-4">
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          field[1].input_type
                                        }
                                        inputName={
                                          field[1].field_name
                                        }
                                        inputValue={
                                          field[1].value
                                        }
                                        isInputMandatory={
                                          field[1].is_mandatory
                                        }
                                        inputLabel={
                                          field[1].label
                                        }
                                        index={index}
                                        handleOnChange={(e)=>handleInputChange(e, field[1].is_mandatory, "other_check", checkId)}
                                        options={
                                          optionsKey[
                                            field[1].field_name
                                          ]
                                            ? optionsKey[
                                            field[1]
                                              .field_name
                                            ]
                                            : []
                                        }
                                        isField={true}
                                        readOnly={nonEditableFieldsAfterFirstSave.includes(
                                          field[1].field_name
                                        )}
                                      />

                                      {errorData[
                                        field[1].field_name
                                      ] === true ? (
                                        field[1].value ===
                                          "" ||
                                          field[1].value ===
                                          null ? (
                                          <p className="text-danger">
                                            This is a required field.
                                          </p>
                                        ) : (
                                          <p className="text-danger">
                                            Please provide valid input
                                          </p>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )
                            })
                          )
                        }
                      </div>
                      <div className="row">
                        {
                          checkFieldnDoc?.docs && Object.entries(checkFieldnDoc?.docs || {})?.length > 0 && (
                            Object.entries(checkFieldnDoc?.docs)?.map((docField, index) => {
                              console.log("fields other details...", docField)
                              return (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        docField[1].input_type
                                      }
                                      inputName={
                                        docField[1].field_name
                                      }
                                      inputValue={
                                        docField[1].value
                                      }
                                      errorField={docField[1].field_name}
                                      uploadedFilePreview={
                                        docField[1].preview &&
                                        docField[1].preview
                                          .preview_key
                                          ? docField[1].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        docField[1].is_mandatory
                                      }
                                      inputLabel={
                                        docField[1].label
                                      }
                                      index={index}
                                      handleFileUpload={handleFileUpload}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                      hideOtherOption = {true}
                                    />
                                      {/* <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - jpg, png & jpeg are
                                        preferred
                                      </small> */}
                                    {errorData[
                                      docField[1].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload file
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )
                            })
                          )
                        }
                      </div>
                      </>
                    )

                  })}
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                    {
                      personalDetailsData.data?.isVerifyEmail == 0 ||
                      personalDetailsData.data?.isEmailVerified == 1 || 
                      verifyEmailData.status == "success" ?
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        // onClick={(e) => checkBeforeSave1(e)}
                        onClick={(e) => SubmitPopup(e)}
                        // onclick={setShowSubmitPopup(true)}
                      >
                        Save
                      </button>: <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        disabled
                      >
                        Save
                      </button>}
                    </div>
                  </div>
                  {personalDetails.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
                </form>
                <Footer />
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default CandidatePersonalDetails;
